import { AfterViewInit, Component, Input, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { ConfigService } from "../../shared/services/config.service"
import { InstitutionService } from "src/app/shared/services/institution.service"
import { ThemeColor, ThemeService } from "src/app/shared/services/theme/theme.service"

@Component({
  selector: "app-wifi-access-code",
  templateUrl: "./wifi-access-code.component.html",
  styleUrls: ["./wifi-access-code.component.scss"]
})
export class WifiAccessCodeComponent {

  @Input()
  accessCode: string

  @Input()
  passWord?: string

  @Input()
  email?: string

  constructor(
    private institutionService: InstitutionService,
    private themeService: ThemeService,
    private configService: ConfigService,
    private router: Router
  ) { /* do nothing */ }

  goToWifiConnection(): void {
    this.configService.setAccessCode(this.accessCode)
    this.router.navigate(["/wifi-connection"])
  }
}

